import React, { Component } from "react";
import { connect } from "react-redux";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import UploadFiles from "../../components/UploadFiles/UploadFiles";
import { DateLabel } from "../../components/Labels";
import messages from "../../assets/i18n";
import { withRouter } from "react-router-dom";
import "./ReconcilePage.scss";
import { HeaderActions, FooterActions, LoadingSpinner, ToastMessage } from "../../components";
import { bindActionCreators } from "redux";
import { Creators as actionsConciliationResult } from '../../store/ducks/conciliationResult'

class ReconcilePage extends Component {
	pageBack = () => {
		this.props.history.push(`/main`);
	};

	constructor(props) {
		super(props);
		this.state = {
			uploadedFile: null,
			file: null,
			formError: null,
			formMessage: { type: "error", message: "" },
			isLoading: false,
			fileStep: '',
			toastShow: false,
		};
	}

	setToastShow = (newShow) => {
		this.setState({toastShow: newShow})
	}

	validateAndStoreLocalFile = file => {
		const { lang } = this.props;

		this.props.resetReconcile();

		this.setState({
			firstStep: '',
			uploadedFile: null,
			formMessage: {
				type: "error",
				message: ""
			}
		});

		if (file.length === 0) {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].mustBeXML
				}
			});
		}

		if (file.length > 1) {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].sendInvoice
				}
			});
		}

		file = file[0];
		if (file && file.type !== "text/xml") {
			this.setToastShow(true);
			return this.setState({
				formMessage: {
					type: "error",
					message: messages[lang].mustBeXML
				}
			});
		}

		this.setState({
			uploadedFile: file,
			file: file
		});


	};


	reconcile = (file, orderId) => {
		if (this.state.uploadedFile) {

			const { lang } = this.props;
			let reader = new FileReader();
			reader.readAsBinaryString(file);

			// read the file content
			reader.onload = () => {
				const regexp = /<nfeProc +.*versao="4.\d+".*>/i
				let found = reader.result.search(regexp);

				// test if the file contains the nfe 4.0 header
				if (found <= -1) {
					this.setToastShow(true);
					this.setState({
						fileStep: false,
						formMessage: {
							type: "error",
							message: messages[lang].fileIsNotNFe,
						}
					});
					this.props.dispatchFileStep(false)
				} else {
					let base64 = new FileReader();
					base64.readAsDataURL(file);
					base64.onload = () => {
						file.result = base64.result.split(',')[1];
					}

					this.setState({
						fileStep: true,
						isLoading: true
					})
					this.props.dispatchConciliation(file, orderId);
					this.props.dispatchFileStep(true)
				}
			};
		}
	};

	componentDidMount = () => {
		if (this.props.orderList && this.props.orderList[0] ) {
			this.props.dispatchConciliationResult(this.props.orderList[0])
		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (this.props !== prevProps) {
			this.testReconciledSuccessfully();
		}

		if (this.state.fileStep !== prevState.fileStep && this.state.fileStep === true) {
			this.props.history.push(`/conciliation-status`);
		}

		if (this.props.conciliationResult.result &&
					this.props.conciliationResult.result.pedido &&
					this.props.conciliationResult.result.pedido.id === this.props.orderList[0].id && 
					this.props.conciliationResult.result.statusConciliacaoComercial &&
					this.props.conciliationResult.result.statusConciliacaoFiscal &&
					this.props.conciliationResult.result.statusConciliacaoComercial.id === '2' &&
					(this.props.conciliationResult.result.statusConciliacaoFiscal.id === "2" || 
					this.props.conciliationResult.result.statusConciliacaoFiscal.id === "4")) {
			this.props.history.push(`/conciliation-status`);
		} else {
			if (this.props.conciliationResult.result &&
						this.props.conciliationResult.result.statusConciliacaoComercial &&
						this.props.conciliationResult.result.statusConciliacaoFiscal) {
				this.props.dispatchConciliationResultClean(this.props.orderList[0])
			}
		}

		
	};

	testReconciledSuccessfully = () => {

		const { tradeConciliation, taxConciliation } = this.props

		if (this.state.uploadedFile) {

			if (tradeConciliation === false) {
				this.setToastShow(true);
				this.setState({
					isLoading: false,
					formMessage: {
						type: "error",
						message: messages[this.props.lang.name].reconcileError
					}
				})
			}

			if (taxConciliation !== "") {
				this.setState({
					isLoading: false
				})
			}

			if (tradeConciliation === true && taxConciliation === true) {
				this.setToastShow(true);
				this.setState({
					isLoading: false,
					formMessage: {
						type: "success",
						message: messages[this.props.lang.name].reconcileSuccess
					}
				})
			} else if (tradeConciliation === true && taxConciliation === false) {
				this.setToastShow(true);
				this.setState({
					isLoading: false,
					formMessage: {
						type: "error",
						message: messages[this.props.lang.name].reconcileError
					}
				})
			}

		} else {
			this.setState({
				isLoading: false
			})
		};
	};

	removeFile = () => {
		this.setState({
			fileStep: '',
			uploadedFile: null,
			formMessage: { type: "error", message: "" },
			file: ''
		});
		this.props.dispatchFileStep('')
		this.props.resetReconcile()
	};

	titlePage = (order) => {
		const { lang } = this.props;
		return (
			<>
				{messages[lang].reconcileFile} {order.id}
				<span className="ml-5 font-weight-normal word-spacing-15">
					{order.calendarioComercial ? order.calendarioComercial.semanaComercial : ''}
				  {" | "} 
					<DateLabel date={new Date(order.dtEmissao)}	/>
					{" "} 
					<span className="word-spacing-0">
						{order.qtCompra} {messages[lang].parts}
					</span>
				</span>
			</>
		)
	}

	buttonConcile = (order, file) => () => (
		<ButtonStandard
			id="reconcile_reconcile_button"
			disabled={
				!this.state.uploadedFile ||
					this.state.formMessage.message
					? true
					: false
			}
			text={messages[this.props.lang].reconcile}
			textClass="text-3"
			isLoading={this.state.isLoading}
			className="btn btn-primary px-3 py-2 btn-light"
			onClick={() => this.reconcile(file, order.id)}
		/>
	)

	render() {
		const { file } = this.state;
		const { orderList } = this.props;
		const order = orderList[0] ? orderList[0] : [];

		return (
			<div className="page-reconcile">
				<ToastMessage 
					show={this.state.toastShow} 
					setShow={this.setToastShow} 
					message={this.state.formMessage.message}
					toastClass={this.state.formMessage.type === 'success' ? 'toast-success' : 'toast-error' }  />
				<HeaderActions pageBack={this.pageBack} titlePage={this.titlePage(order)} />

				{
					this.props.conciliationResult.isLoading && 
						<LoadingSpinner />
				}
				{
					!this.props.conciliationResult.isLoading && 
						<UploadFiles
							validateAndStoreLocalFile={this.validateAndStoreLocalFile}
							uploadedFile={this.state.uploadedFile}
							removeFile={this.state.formMessage.type !== "success" ? this.removeFile : null}
						/>
				}
				
				<FooterActions ButtonGroupRight={this.buttonConcile(order, file)} />
			</div>
		);
	}
}

const mapStateToProps = state => ({
	orderList: state.orderList,
	lang: state.language.name,
	conciliationResult: state.conciliationResult,
});

const mapDispatchToProps = dispatch => {
	return {
		dispatchConciliation: (file, orderId) =>
			dispatch({
				type: "CONCILIATION_REQUEST",
				file: file,
				orderId: orderId
			}),
		resetReconcile: () =>
			dispatch({
				type: "RESET_RECONCILE"
			}),
		dispatchFileStep: (fileStep) =>
			dispatch({
				type: "FILE_STEP",
				fileStep: fileStep
			}),
		dispatchConciliationResult: (order) => {
			return dispatch({
				type: "GET_CONCILIATION_RESULT",
				payload: order
			})},
		dispatchConciliationResultClean: bindActionCreators(actionsConciliationResult.conciliationResultClean, dispatch)
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(ReconcilePage)
);
